export const PageInnerTitle = ({children}) => (
  <span className="position-relative h4 d-block pb-4 font-weight-bold">
    {children}
  </span>
);
